<template>
<div class='uploadImg'>
  <template v-if='uplogType!==4'>
     
      <van-uploader
              v-model="fileList" 
              multiple
              :max-count="9"
              :after-read="afterRead"
               @delete="deleteFile"  :before-read="beforeRead" 
            >
            </van-uploader>
  </template> 
<template v-else>
    <div class='addImg'>
        <input type="file" accept="image/*" ref="img_file" @change="copeImg" />
        <img :src="option.img" v-if="option.img">
    </div>
    <template v-if="crap">
      <van-popup v-model="crap" class="textPopup" :close-on-click-overlay='false' style=' width: 95%;'>
        <div class='inputCon'>
         <div class="info-item ">
                <div class="line" style="margin-left: -80px;">
                    <div class="cropper-content" style="margin:20px auto;">
                        <div class="cropper">
                            <vueCropper
                                ref="cropper"
                                :img="option.img"
                                :outputSize="option.size"
                                :outputType="option.outputType"
                                :info="true"
                                :full="option.full"
                                :canMove="option.canMove"
                                :canMoveBox="option.canMoveBox"
                                :original="option.original"
                                :autoCrop="option.autoCrop"
                                :autoCropWidth="option.autoCropWidth"
                                :autoCropHeight="option.autoCropHeight"
                                :fixedBox="option.fixedBox"
                                @realTime="realTime">
                            </vueCropper>
                        </div>
                        <div>
                            <div class="show-preview">
                                <div class="preview">
                                    <img :src="previews.url" :style="previews.img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div  class='btn'>
                <p @click="crap = false" >取消</p>
                <p @click="uploadImg">确定</p>
            </div>
        </div>
      </van-popup>
    </template>

  </template>
</div>
  
</template>
<script>
 import "@/utils/talkweb-main-sdk-2.0.0.js";
import { VueCropper } from "vue-cropper";
export default {
  data() {
    return {
      imageUrl:'',//链接地址
      length:9,
      imgData: [],
      fileList:[],
      headImg: "",//裁剪后的base64
      //剪切图片上传
      crap: false,
      previews: {},
      option: {
        img: "",
        outputSize: 1, //剪切后的图片质量（0.1-1）
        full: false, //输出原图比例截图 props名full
        outputType: "png",
        canMove: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        fixedBox: true
      },
      emitFileName:''
    };
  },
  components: {
    VueCropper
  },
  props: ["uplogType",'imgs','len'],
  created() {
    
    if(this.len){
      this.length=this.len;
    }
  },
  methods: {
    afterRead(fileObj) {
      const { file } = fileObj;
      fileObj.status='uploading';
       fileObj.message = '上传中...';
      this.handleAvatarSuccess(file,fileObj);
    },
    beforeRead(file){console.log(file.type);
      let str='image/jpeg, image/jpg, image/png, video/mp4';
      if(str.indexOf(file.type)<0){
        this.$toast('请上传jpg/jpeg/png/mp4格式');
        return false;
      }
      return true;
    },
    deleteFile(file,obj) {
      console.log(file);
      this.imgData.splice(obj.index,1);
    },
    handleAvatarSuccess(file,fileObj) {
        let _appID = 'esi-storage';
        let storageEndPoint = window.ENV_API.API_HOST + "/consoleapi/storage";
        let appName=window.ENV_API.API_HOST + '/app';
        let fileParams = {
            file:file,
            fileName:file.name
        };
      let sc =new talkwebStorage.StorageClient(_appID,storageEndPoint,"Bearer "+ window.sessionStorage.getItem("loginToken"),appName);
          sc.upload(fileParams).then((res) => {
            fileObj.status='done';
            //  const { accessUrl } = res.result;
            if(this.uplogType==4){
                this.crap = false;
                this.option.img =res.result.accessUrl;
            }else{
              this.imgData.push(res.result);
            }
              
              this.$emit('active',res.result.accessUrl);
            
      }).catch((err) => {
        fileObj.status='failed';
        fileObj.message = '上传失败';
          this.$toast(err);
      });
    },
    warningFile() {
      this.$toast('文件数量不能超过5个');
    },
      handleClose(){
        this.crap=false;
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        // const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isJPG && isLt2M;
      },
    uploadImg() {
      //文件上传
      this.$refs.cropper.getCropBlob(data => {
        let blob=window.URL.createObjectURL(data);
        this.downImg=blob;
        var base64;
        var img=new Image();
        img.src=blob;
        var _that=this;
        img.onload=function(){
          var that=this;
          var w=that.width,h=that.height,
          scale=w / h;h=w / scale;
          var canvas=document.createElement('canvas');
          var ctx=canvas.getContext('2d');
          canvas.width=w;canvas.height=h;
          ctx.drawImage(that,0,0,w,h);
          //生成base64
          _that.cropperPic=canvas.toDataURL("image/jpeg",0.8);
          let files=_that.transformToFile(_that.cropperPic,_that.emitFileName);
          _that.temporaryCloseCropper=true;
          _that.handleAvatarSuccess(files);
         
        }
        
      });
    
    },
    //base64转成files
    transformToFile(dataurl,filename){
      var arr=dataurl.split(','),
         mime=arr[0].match(/:(.*?);/)[1],
         bstr=atob(arr[1]),
         n=bstr.length,
         u8arr=new Uint8Array(n);
         while(n--){
           u8arr[n]=bstr.charCodeAt(n);
         }
         return new File([u8arr],filename,{type:mime})
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data;
      this.$refs.cropper.getCropData(data => {
        // do something
        //  console.log(data)
        this.headImg = data;
      });
    },
    //选择本地图片
    copeImg(e, num) {
      var _this = this;
      //上传图片
      var file = e.target.files[0];
      _this.emitFileName = file.name;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      let reader = new FileReader()
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
         _this.option.img = data;
     
        this.crap=true;
      };
      // 转化为base64
     reader.readAsDataURL(file);
     
    },
   
   
  },
  watch: {
    imgs(news,olds){
      if(news){
        if(this.uplogType==4){
           this.option.img=this.imgs;
        }
        
      }
     
    }
  }
};
</script>
<style lang="scss">
.uploadImg {
  .img{
    display: inline-block;
    margin-right: .1rem;
    img{
      width: 80px;
      height: 80px;
    }
  }
  .info-item {
      display: flex;
      justify-content: center;
      .cropper-content {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            -webkit-justify-content: flex-end;
            .cropper {
                width: 290px;
                height: 260px;
            }
            .show-preview {
                flex: 1;
                -webkit-flex: 1;
                display: flex;
                display: -webkit-flex;
                justify-content: center;
                -webkit-justify-content: center;
                .preview {
                    overflow: hidden;
                    border-radius: 50%;
                    border: 1px solid #cccccc;
                    background: #cccccc;
                    width:100px;
                    height: 100px;
                    margin-left: 20px;
                }
            }
        }
  }
  .addImg{
    display: flex;
    justify-content: center;
    align-items: center;
    input{
      opacity: 0;
      position: absolute;
    }
    img{
      width:40px;
      height: 40px;
      border-radius:50%;
    }
  }
}

</style>
